module.exports = __webpack_public_path__ + "img/katarina_outside_23.d5d57566.jpg";